import type React from "react";
import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";

type Props = {
	contextValue: string;
	setter: string;
	className?: string;
	widgetId: string;
	children: React.ReactNode;
};

export const ButtonWithContext: React.FC<Props & DropdownProps> = ({
	contextValue,
	state,
	onStateChange,
	setter,
	children,
	className,
	widgetId,
	...otherProps
}) => {
	const value = state?.[contextValue];

	return (
		<button
			type="button"
			className={`font-bold ${value ? "text-gold" : "text-light-gray"} ${className}`}
			onClick={() => onStateChange({ [contextValue]: !value })}
			{...otherProps}
		>
			{children}
		</button>
	);
};
